let patched = false

export default defineNuxtPlugin(() => {
  if (patched) return
  patched = true

  const originalWarn = console.warn
  console.warn = (...args) => {
    const message = args[0]
    if (typeof message === 'string' && message.includes('Extraneous non-props attributes (class) were passed to component')) {
      originalWarn.call(console, 'VSlideGroupItem: Extraneous class attribute warning suppressed')
      return
    }
    originalWarn.apply(console, args)
  }
})